import React from 'react';
import { graphql } from 'gatsby';
import cn from 'classnames';
import style from './button.mod.scss';
import Arc from '../global/icons/arc';
import Navigator from '../global/navigator/navigator';

const Button = ({
  centered = false,
  icon = true,
  primary = false,
  secondary = false,
  text = 'Learn more',
  type = '',
  large = false,
  to = '/',
  pageId,
  onClick
}) => {
  const classes = cn(style.button, {
    [style[`button--centered`]]: centered,
    [style[`button--primary`]]: primary,
    [style[`button--secondary`]]: secondary,
    [style[`button--large`]]: large,
  });

  if (pageId) {
    return (
      <Navigator className={classes} recordId={pageId}>
        <ButtonContent text={text} icon={icon} />
      </Navigator>
    );
  } else if (type === 'submit') {
    return (
      <button className={classes} type={type}>
        <ButtonContent text={text} icon={icon} />
      </button>
    );
  } else if (type === 'button') {
    return (
      <button className={classes} type={type} onClick={onClick}>
        <ButtonContent text={text} icon={icon} />
      </button>
    );
  } else {
    return (
      <a className={classes} href={to}>
        <ButtonContent text={text} icon={icon} />
      </a>
    );
  }
};

const ButtonContent = ({ text, icon }) => (
  <div>
    {text}
  </div>
);

export default Button;

export const query = graphql`
  fragment InternalLink on DatoCmsInternalLink {
    text
    id: originalId
    page {
      ... on DatoCmsHomepage {
        id: originalId
      }
      ... on DatoCmsPage {
        id: originalId
      }
    }
  }
`;
